import { useMemo } from 'react';
import { useUserContext } from '../store/user_context';

export default function useAuth() {
  const { user } = useUserContext();

  const hasRole = useMemo(() => {
    return (roles = []) => {
      if (!roles || roles.length === 0) return true;

      // normalize user roleNames to array
      const userRoleNames = Array.isArray(user?.roleNames)
        ? user.roleNames
        : [user?.roleNames].filter(Boolean);

      if (userRoleNames.length === 0) return false;

      // check if any required role matches user roleIds
      return roles.some(r => userRoleNames.includes(r));
    };
  }, [user]);

  return { user, hasRole };
}
